import { IValidateVisibleViolationsSuccess } from './types';

export const DEFAULT_RESPONSE: IValidateVisibleViolationsSuccess = {
  isValid: true,
};
